import { makeSupabaseClient } from '@/shared/infra/supabase'
import { SupabaseSubscribeConnectRepository } from '@/modules/connect/infra'
import type { SubscribeConnect } from '@/modules/connect/use-cases'

export function makeSubscribeConnect(): SubscribeConnect {
  return new SupabaseSubscribeConnectRepository(makeSupabaseClient()).execute
}
